import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getWalletDetails } from "../Api/api";
import { CgSpinner } from "react-icons/cg";
import { AuthContext } from "./AuthProvider";
import { WalletCard } from "./WalletCard";

interface UserDetails {
    _id: string;
    name: string;
    email: string;
    firebaseUID: string;
    profilePic: string;
    profilePicThumb: string;
}

interface ClubDetails {
    _id: string;
    name: string;
    email: string;
    address: string;
    photo_url: string | null;
    timezone: string;
  }
  
  interface ClubCreditDetails {
    _id: string;
    club_id: string;
    player_id: string;
    chat_id: string | null;
    membership_id: string | null;
    club_coin: number;
    credit: number;
    following: boolean;
    notification: {
      status: boolean;
      match_post: boolean;
      tournament_post: boolean;
      training_post: boolean;
    };
    payment_status: string | null;
    next_payment: number | null;
    subscription_id: string | null;
    followDate: string;
  }
  
  interface PurchasedCredit {
    _id: string;
    club_id: string;
    player_id: string;
    credit_package_id: string | null;
    type: string;
    purchased_price: number | null;
    expire_at: string;
    purchased_credits: number;
    remaining_credits: number;
    player_name: string | null;
    player_email: string | null;
    credit_package_title: string | null;
    note: string | null;
    createdAt: string;
    updatedAt: string;
  }

interface FollowingClubCreditDetails {
    clubDetails: ClubDetails;
    clubCreditDetails: ClubCreditDetails;
    purchasedCredits: PurchasedCredit[];
}

interface IWalletData {
    userDetails: UserDetails;
    totalCredits: number;
    followingClubCreditDetails: FollowingClubCreditDetails[];
}

export const WalletComponent = () => {
    const currentUser = useContext(AuthContext);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [walletData, setWalletData] = useState<IWalletData | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchWalletData = async () => {
          try {
            setLoading(true);
            const response = await getWalletDetails();
            setWalletData({
              ...response,
              followingClubCreditDetails: response?.followingClubCreditDetails?.filter(
                (item: any) => item?.purchasedCredits?.length > 0
              ) || [],
            });
          } catch (error) {
            console.error("Failed to fetch wallet data:", error);
          } finally {
            setLoading(false);
          }
        };
    
        fetchWalletData();
      }, []);

    return (
        <div className="py-8 px-4">
            {!currentUser ? (
                <button
                    className="hover:underline"
                    onClick={() => navigate("/sign-in")}
                >
                    {t("loginToCheckWallet")}
                </button>
            ) : (
                <>
                    {loading ? (
                        <div className="flex justify-center items-center mt-10">
                            <CgSpinner className="animate-spin text-[24px]" />
                        </div>
                    ) : (
                        <div className="flex flex-row flex-wrap gap-4 justify-center">
                            {walletData?.followingClubCreditDetails && walletData?.followingClubCreditDetails?.length ? (
                                walletData?.followingClubCreditDetails?.map((item: any, index) => (
                                    <WalletCard key={index} item={item} />
                                ))
                            ) : (
                                <p className="text-[15px]">
                                    {t("noDataFound")}
                                </p>
                            )}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

